export enum WebSocketTopic {
    SyncStatus = 0,
    PublicNodeStatus = 1,
    NodeStatus = 2,
    MPSMetrics = 3,
    TipSelMetric = 4,
    Ms = 5,
    PeerMetric = 6,
    ConfirmedMsMetrics = 7,
    Vertex = 8,
    SolidInfo = 9,
    ConfirmedInfo = 10,
    MilestoneInfo = 11,
    TipInfo = 12,
    DBSizeMetric = 13,
    DBCleanup = 14,
    SpamMetrics = 15,
    AvgSpamMetrics = 16
}
